import { createContext, useContext } from "react";
import {QueueUpdateForm} from "../classes/Queue";

export const defaultQueueUpdateFormValue = {
    form : new QueueUpdateForm({}), 
    data : null
}

const QueueUpdateContactContext = createContext(defaultQueueUpdateFormValue)
export default QueueUpdateContactContext

export const useFormUpdateContactContext = () => {
    const [updateContactData, setUpdateContact] = useContext(QueueUpdateContactContext)
    return { updateContactData, setUpdateContact }
}